import { Box, Typography } from '@mui/material';
import { TournamentBracketParticipantResultEntity } from '@okletsplay/core';
import { DefaultDisplayValue } from 'app/enums';
import { Identifier } from 'app/interfaces';
import { sum } from 'lodash';
import isEmpty from 'lodash/isEmpty';
import React, { FC, useMemo } from 'react';
import { Info } from 'shared/components/Info';

interface BracketTeamResultProps {
  matchResults: Record<Identifier, TournamentBracketParticipantResultEntity[]>;
  teamId: Identifier;
}

export const BracketTeamResult: FC<BracketTeamResultProps> = ({ matchResults, teamId }) => {
  const isResultDetailsAvailable = useMemo(
    () => Boolean(Object.values(matchResults)?.find((results) => results?.length > 1)),
    [matchResults]
  );

  const teamScore = useMemo(() => {
    const resultsWithScore =
      matchResults?.[teamId]?.filter((result) => typeof result.score === 'number') ?? [];
    const scores = resultsWithScore.map((result) => result.score);
    return scores.length ? sum(scores) : DefaultDisplayValue.DASH;
  }, [matchResults, teamId]);

  if (isEmpty(matchResults)) {
    return null;
  }

  if (!isResultDetailsAvailable) {
    return <Typography>{teamScore}</Typography>;
  }

  return (
    <Info width={175} iconSize={14} control={<Typography>{teamScore}</Typography>}>
      <>
        <Typography>Match Game Results</Typography>
        <Box>
          {Object.values(matchResults).map((results, index) => (
            <Box key={index} display="flex">
              {results.map((result, resultIndex) => (
                <Typography key={`${result.id}-${resultIndex}`} pr={1}>
                  {result.score ?? DefaultDisplayValue.DASH}
                </Typography>
              ))}
            </Box>
          ))}
        </Box>
      </>
    </Info>
  );
};
